module.exports = __webpack_public_path__ + "img/hd22.6b82dc08.png";